import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page1',
  templateUrl: './page1.component.html',
  styleUrls: ['./page1.component.css']
})
export class Page1Component implements OnInit {


  public products = [
    {
    id: '1',
    title: 'Huarache Sencillo',
    image: 'https://www.mediafire.com/convkey/48d4/f80yy37y85v2jgezg.jpg',
    precio: '15',
    descripcion: 'Salsa a elegir: Verde, roja o bandera'
   
  },
  {
    id: '2',
    title: 'Huarache Especial',
    image: 'https://www.mediafire.com/convkey/d9f8/fa8v8gf3byko5abzg.jpg',
    precio: '25',
    descripcion: 'Incluye todos los ingredientes'
  },
  {
    id: '3',
    title: 'Huarache Vegano',
    image: 'https://www.mediafire.com/convkey/eac0/iq0w5u7wg4amyfbzg.jpg',
    precio: '23',
    cu: 'c/u',
    descripcion: 'Sin grasa, Sin salsa, Sin queso, $20 c/u',
  },
  {
    id: '4',
    title: 'Huarache con Huevo',
    image: 'https://www.mediafire.com/convkey/812a/ap498md77xaq6jnzg.jpg',
    precio: '23',
    descripcion: 'Ingrediente: Huevo, queso, Salsa a elegir: Verde, roja o bandera',
   
    "margin-bottom": "100px",
  },
  {
    id: '5',
    title: 'Huarachito',
    image: 'https://www.mediafire.com/convkey/0ff1/mxxv57t4e905y32zg.jpg',
    precio: '12',
    descripcion: 'Ingrediente: Pechuga deshebrada (Queso gratinado)',
  },
  {
    id: '6',
    title: 'Huarachito',
    image: 'https://www.mediafire.com/convkey/b4e5/bor0v9p59vxdsoozg.jpg',
    precio: '12',
    descripcion: 'Ingrediente: Bistec y nopales (Queso gratinado)',
  },
  {
    id: '7',
    title: 'Orden de Memelas',
    image: 'https://www.mediafire.com/convkey/0fc7/jhdfl2qua8uhs30zg.jpg',
    precio: '16',
    descripcion: '1 Orden de memelas (4 memelas) Salsa a elegir: verde, roja o bandera',
  },
  {
    id: '8',
    title: 'Huarache con Milanesa',
    image: 'https://www.mediafire.com/convkey/e47e/1ffyfvqv7wuq90kzg.jpg',
    precio: '30',
    descripcion: 'Ingrediente: Una pieza de milanesa',
  },
  {
    id: '9',
    title: 'Huarache con Enchilada',
    image: 'https://www.mediafire.com/convkey/fb7e/43oamdo0lnudtkvzg.jpg',
    precio: '30',
    descripcion: 'Ingrediente: Una pieza de enchilada',
  },
  {
    id: '10',
    title: 'Quesadillas',
    image: 'assets/img/img10.jpg',
    precio: '15',
    descripcion: 'Ingredientes a elegir: Tlales, bistec, Chroizo, picadillo, champiñones, $15 c/u',
  },
  {
    id: '11',
    title: 'Pozole 1LT',
    image: 'https://www.mediafire.com/convkey/5b31/cee1cbcvtt852zczg.jpg',
    precio: '60',
    descripcion: 'Incluye: Limones, rabanos, lechuga, totopos',
    p: 'SÓLO DOMINGOS'
  },
  {
    id: '12',
    title: 'Carne con ensalada',
    image: 'https://www.mediafire.com/convkey/6f91/5xfuycoquqwj672zg.jpg',
    precio: '40',
    descripcion: 'Incluye: Ensalada, salsa, frijoles, tortillas de mano '
  },
  {
    id: '13',
    title: 'Chilaquiles Rojos',
    image: 'https://www.mediafire.com/convkey/8d88/lebp90200nzodf1zg.jpg',
    precio: '30',
    descripcion: 'Incluye: frijoles, y una pieza de pan'
  }
 ]   
  constructor() { }

  ngOnInit(): void {
    function isMobile() {
      if (sessionStorage.desktop)
          return false;
      else if (localStorage.mobile)
          return true;
      var mobile = ['iphone', 'ipad', 'android', 'blackberry', 'nokia', 'opera mini', 'windows mobile', 'windows phone', 'iemobile'];
      for (var i in mobile)
          if (navigator.userAgent.toLowerCase().indexOf(mobile[i].toLowerCase()) > 0) return true;
      return false;
  }

/* 
    var sendbtn = document.querySelector('#sendbtn');
    sendbtn.addEventListener('click', enviarMensaje) */
    const formulario = document.querySelector('#formulario');
    const buttonSubmit = document.querySelector('#sendbtn');
    const urlDesktop = 'https://web.whatsapp.com/';
    const urlMobile = 'whatsapp://';
    const telefono = '522381733121';
    
    formulario.addEventListener('submit', (event) => {
        event.preventDefault()
        buttonSubmit.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        
        setTimeout(() => {
            let inputName = (<HTMLInputElement>document.getElementById('formGroupExampleInput')).value;
            let textareame = (<HTMLInputElement>document.getElementById('exampleFormControlTextarea1')).value;
            let domicilio = (<HTMLInputElement>document.getElementById('domicilioText')).value;
            let mensaje = 'send?phone=' + telefono + '&text=%0A*Nombre:%0A' + inputName + '%0A*Domicilio:%0A' + domicilio + '%0A*Orden:%0A' +  textareame + ''
            if(isMobile()) {
                window.open(urlMobile + mensaje, '_blank')
            }else{
                window.open(urlDesktop + mensaje, '_blank')
            }
            buttonSubmit.innerHTML = '<i class="fab fa-whatsapp"></i> Enviar WhatsApp'
            
        }, 3000);
    });


  /*   function enviarMensaje() {
      let inputName = document.querySelector('#formGroupExampleInput').value
      let textareame = (document.querySelector('#exampleFormControlTextarea1') as HTMLTextAreaElement).value;
      let domicilio = (document.querySelector('#domicilioText') as HTMLTextAreaElement).value;
      let url = "https://api.whatsapp.com/send?phone=522381733121&text=Nombre: %0A" + inputName + "%0A%0ADomicilio: %0A" + domicilio + "%0A%0AOrden: %0A" + textareame + "%0A";
      window.open(url);


    } */
  }
  
}


